import { useQuery } from '@tanstack/react-query';
import { AlertRuleApi } from '../../../apis/AlertRuleApi/AlertRuleApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IAlertRule } from '../Alert';

export function useAlertRules() {
    return useQuery<IAlertRule[]>({
        queryKey: [QueryKeys.alertRules],
        queryFn: () => AlertRuleApi.getAlertRules(),
    });
}
